import { IS_PROD } from "@/helpers/constants";
import { FACEBOOK_STANDARD_EVENTS } from "./facebook-events";

export function trackFacebookEvent(
  eventName: string,
  data?: Record<string, string | number | boolean> | string | number
) {
  if (window.fbq && IS_PROD) {
    if (data) {
      window.fbq("trackCustom", eventName, data);
    } else {
      window.fbq("trackCustom", eventName);
    }
  }
}

export function trackFacebookPurchaseEvent({
  amount = 6000,
  currency = "NGN",
}: {
  amount: number;
  currency: string;
}) {
  const amountWithDecimals = amount - 0.01;

  if (window.fbq && IS_PROD) {
    window.fbq("track", FACEBOOK_STANDARD_EVENTS.PURCHASE, {
      value: amountWithDecimals,
      currency: currency,
    });
  }
}

export function trackFacebookStandardEvent(
  eventName: FACEBOOK_STANDARD_EVENTS
) {
  if (window.fbq && IS_PROD) {
    window.fbq("track", eventName);
  }
}
